function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: ".5",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.2 15.8c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8V7.1h6.4v8.8H9.4z",
  fill: "#FBFCFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6 8.6h2.3M9.6 9.8h2m-2 1.2h3.2m-3.2 1.2h2m-2 1.2h3.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.8 14.4c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8V5.7h6.4v8.8H8z",
  fill: "#FBFCFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.2 7.2h2.3M8.2 8.4h2m-2 1.2h3.2m-3.2 1.2h2m-2 1.2h3.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.4 13c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8V4.2h6.4V13H6.4z",
  fill: "#FBFCFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.8 5.8h2.3M6.8 7h2m-2 1.2H10M6.8 9.4h2m-2 1.2H10"
})));